import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
/*import { CalendarOptions, EventContentArg, EventSourceInput, FullCalendarComponent } from '@fullcalendar/angular';*/
import { BreadDik, Person, QueovalDate, QueovalParam } from '../../../../models';
import { EtatPresence, PlanningOnglet, ReservationPlanning } from '../../../../models/formation/planning.model';
import { CoreService, QueovalDateService } from '../../../../services';
import { PlanningService } from './planning.service';

@Pipe({
  name: 'PersonToListId'
})
export class FormateursIdPipe implements PipeTransform {
  constructor() { }
  /** retourne une liste d'ident depuis une liste de Person */
  transform(pPerson: Array<Person>): Array<string> {
    if (pPerson && pPerson.length > 0) {
      return pPerson.map(p => p.Id);
    }
    else {
      return [];
    }
  }
}

@Pipe({
  name: 'NumbertoFixed'
})
export class NumberToFixedPipe implements PipeTransform {
  constructor() { }
  /** retourne une liste d'ident depuis une liste de Person */
  transform(pNumber: number, pfixTo: number = 2): string{
    if (Number.isNaN(pNumber) || !pNumber)
      return (0).toFixed(pfixTo);
    return pNumber.toFixed(pfixTo);
  }
}
